import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

export const CatalogBannerAvailable = () => {
  const i18n = useI18n();

  return (
    <section className="flex overflow-hidden relative flex-col gap-1.5 justify-center p-5 bg-yellow rounded-md lg:flex-row lg:gap-7 lg:p-7">
      <div className="flex gap-2 items-center text-sm sm:text-base">
        <Image
          src="/images/catalog/icons/calendar.svg"
          width={18}
          height={18}
          alt="calendar"
        />
        {i18n.t("catalog.availableBanner.try", {}, { html: true })}
      </div>
      <div className="flex gap-2 items-center text-sm sm:text-base">
        <Image
          src="/images/catalog/icons/cockade.svg"
          width={18}
          height={18}
          alt="cockade"
        />
        {i18n.t("catalog.availableBanner.warranty", {}, { html: true })}
      </div>
      <div className="flex gap-2 items-center text-sm sm:text-base">
        <Image
          src="/images/catalog/icons/delivery.svg"
          width={18}
          height={18}
          alt="delivery"
        />
        {i18n.t("catalog.availableBanner.shipping", {}, { html: true })}
      </div>

      <div className="flex gap-2 items-center text-sm sm:text-base">
        <Image
          src="/images/catalog/icons/security.svg"
          width={18}
          height={18}
          alt="security"
        />
        {i18n.t("catalog.availableBanner.swap", {}, { html: true })}
      </div>

      <div className="absolute -right-20 w-40 h-40 rotate-[10deg] lg:-top-8 lg:!-right-10 xl:!right-0 2xs:-right-5">
        <Image
          src="/images/catalog/banner-available.webp"
          layout="fill"
          alt="smarphones"
        />
      </div>
    </section>
  );
};
